import { getterTree, mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'

export const levels = [
  { name: 'starter', maxPointLimit: 0 },
  { name: 'newbie', maxPointLimit: 30 },
  { name: 'rookie', maxPointLimit: 100 },
  { name: 'challenger', maxPointLimit: 500 },
  { name: 'advanced', maxPointLimit: 1000 },
  { name: 'veteran', maxPointLimit: 3000 },
  { name: 'expert', maxPointLimit: 10000 },
  { name: 'champion', maxPointLimit: 25000 },
  { name: 'hero', maxPointLimit: 50000 }
]

type TotalUserPoints = undefined | number;
interface Level {
  name: string;
  maxPointLimit: number;
}

export const state = () => ({
  totalUserPoints: undefined as TotalUserPoints,
  levels: levels as Level[]
})

export const getters = getterTree(
  state,
  {
    currentLevel({ levels, totalUserPoints }) {
      if (totalUserPoints === undefined) { return }

      let i = levels.length - 1

      if (totalUserPoints >= levels[i].maxPointLimit) { return levels.length - 1 }

      while (totalUserPoints < levels[i].maxPointLimit) { i -= 1 }

      return i
    },
    currentLevelName({ levels }, { currentLevel }) {
      return levels[currentLevel] ? levels[currentLevel].name : ''
    },
    levelPoints({ levels }, { currentLevel }) {
      return levels[currentLevel + 1]
        ? levels[currentLevel + 1].maxPointLimit - levels[currentLevel].maxPointLimit
        : 0
    },
    completedLevelPoints({ levels, totalUserPoints }, { currentLevel }) {
      if (!totalUserPoints || !levels[currentLevel] || levels[currentLevel].maxPointLimit >= totalUserPoints) { return 0 }
      return totalUserPoints - levels[currentLevel].maxPointLimit
    },
    // helper getters
    levelInfo(state, { currentLevel, currentLevelName }) {
      if (currentLevel === undefined || !currentLevelName) { return '' }
      return `LEVEL ${currentLevel} • ${currentLevelName.toUpperCase()}`
    },
    levelProgress(state, { levelPoints, completedLevelPoints }) {
      return !levelPoints ? 0 : Math.trunc(completedLevelPoints * 100 / levelPoints)
    }
  }
)

export const mutations = mutationTree(
  state,
  {
    setState
  }
)

export const actions = actionTree(
  { state, getters, mutations },
  {
    setLevel({ commit, rootGetters }) {
      const id = rootGetters['account/accountId']

      return this.$api.account.account({ id, feature: 'gamePoint' })
        .then((res: Axios.AxiosResponse) => commit('setState', { stateName: 'totalUserPoints', data: res.data.data.points }))
        .catch((res: any) => this.$sentry.captureException(res))
    }
  }
)
